import { Container } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { Image, dynamicImage } from "../../../utils";

const ImageSlideshow = () => {
  const images = [
    "car/slideshow/1.png",
    "car/slideshow/2.png",
    "car/slideshow/3.png",
    "car/slideshow/4.png",
    "car/slideshow/5.png",
    "car/slideshow/6.png",
  ];

  return (
    <div className="image-slideshow-section section-b-space">
      <Container>
      <Swiper
        modules={[Autoplay, Navigation]}
        spaceBetween={0}
        slidesPerView={1}
        autoplay={{ delay: 3500, disableOnInteraction: false }}
        loop={true}
        navigation={true}
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <div className="image-container">
              <Image src={dynamicImage(image)} alt={`slide-${index}`} className="img-fluid" />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      </Container>
    </div>
  );
};

export default ImageSlideshow;